module.exports = __webpack_public_path__ + "img/planning.26d12e3b.svg";